export enum PerfilEnum {
	SEDE = 'SEDE',
	FRANQUIA = 'FRANQUIA',

	ID_SEDE = '2',
	ID_FRANQUIA = '3',
}
